var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98283 0.667969C8.87755 0.667969 7.98153 1.56398 7.98153 2.66927C7.98153 2.8457 8.00436 3.0168 8.04723 3.17977C7.99996 3.18954 7.95331 3.20637 7.90873 3.23068L6.06986 4.2337L3.73071 5.57036C3.7068 5.58402 3.68444 5.59936 3.66371 5.61614C3.36524 5.43923 3.01685 5.33767 2.64473 5.33767C1.53945 5.33767 0.643433 6.23368 0.643433 7.33897C0.643433 8.44426 1.53945 9.34027 2.64473 9.34027C3.22782 9.34027 3.75267 9.0909 4.11845 8.693L6.07079 9.77763L8.04168 10.8527C8.0024 11.0091 7.98153 11.1729 7.98153 11.3416C7.98153 12.4469 8.87755 13.3429 9.98283 13.3429C11.0881 13.3429 11.9841 12.4469 11.9841 11.3416C11.9841 10.2363 11.0881 9.34027 9.98283 9.34027C9.40617 9.34027 8.88647 9.58417 8.52126 9.97444L6.55505 8.90196L4.5902 7.81038C4.6267 7.65921 4.64603 7.50135 4.64603 7.33897C4.64603 6.97894 4.55096 6.64112 4.38456 6.34923L6.55772 5.10743L8.3879 4.10915C8.43262 4.08475 8.47214 4.05452 8.50602 4.01992C8.87193 4.41979 9.3981 4.67057 9.98283 4.67057C11.0881 4.67057 11.9841 3.77456 11.9841 2.66927C11.9841 1.56398 11.0881 0.667969 9.98283 0.667969Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.1aa6e54a6959eb53188cc393ab1ee98b.svg";
export { ForwardRef as ReactComponent };